import api from './api-config';
import { PatientsDTO } from '../models/Patients';

export const patientsService = {
  getAllPatients: async (params?: {
    'id.greaterThan'?: number;
    'id.lessThan'?: number;
    'id.greaterThanOrEqual'?: number;
    'id.lessThanOrEqual'?: number;
    'id.equals'?: number;
    'id.notEquals'?: number;
    'id.specified'?: boolean;
    'id.in'?: number[];
    'id.notIn'?: number[];
    'firstName.contains'?: string;
    'firstName.doesNotContain'?: string;
    'firstName.equals'?: string;
    'firstName.notEquals'?: string;
    'firstName.specified'?: boolean;
    'firstName.in'?: string[];
    'firstName.notIn'?: string[];
    'lastName.contains'?: string;
    'lastName.doesNotContain'?: string;
    'lastName.equals'?: string;
    'lastName.notEquals'?: string;
    'lastName.specified'?: boolean;
    'lastName.in'?: string[];
    'lastName.notIn'?: string[];
    'birthDate.greaterThan'?: string;
    'birthDate.lessThan'?: string;
    'birthDate.greaterThanOrEqual'?: string;
    'birthDate.lessThanOrEqual'?: string;
    'birthDate.equals'?: string;
    'birthDate.notEquals'?: string;
    'birthDate.specified'?: boolean;
    'birthDate.in'?: string[];
    'birthDate.notIn'?: string[];
    'gender.contains'?: string;
    'gender.doesNotContain'?: string;
    'gender.equals'?: string;
    'gender.notEquals'?: string;
    'gender.specified'?: boolean;
    'gender.in'?: string[];
    'gender.notIn'?: string[];
    'taxIdCode.contains'?: string;
    'taxIdCode.doesNotContain'?: string;
    'taxIdCode.equals'?: string;
    'taxIdCode.notEquals'?: string;
    'taxIdCode.specified'?: boolean;
    'taxIdCode.in'?: string[];
    'taxIdCode.notIn'?: string[];
    'street.contains'?: string;
    'street.doesNotContain'?: string;
    'street.equals'?: string;
    'street.notEquals'?: string;
    'street.specified'?: boolean;
    'street.in'?: string[];
    'street.notIn'?: string[];
    'city.contains'?: string;
    'city.doesNotContain'?: string;
    'city.equals'?: string;
    'city.notEquals'?: string;
    'city.specified'?: boolean;
    'city.in'?: string[];
    'city.notIn'?: string[];
    'province.contains'?: string;
    'province.doesNotContain'?: string;
    'province.equals'?: string;
    'province.notEquals'?: string;
    'province.specified'?: boolean;
    'province.in'?: string[];
    'province.notIn'?: string[];
    'postalCode.contains'?: string;
    'postalCode.doesNotContain'?: string;
    'postalCode.equals'?: string;
    'postalCode.notEquals'?: string;
    'postalCode.specified'?: boolean;
    'postalCode.in'?: string[];
    'postalCode.notIn'?: string[];
    'phone.contains'?: string;
    'phone.doesNotContain'?: string;
    'phone.equals'?: string;
    'phone.notEquals'?: string;
    'phone.specified'?: boolean;
    'phone.in'?: string[];
    'phone.notIn'?: string[];
    'email.contains'?: string;
    'email.doesNotContain'?: string;
    'email.equals'?: string;
    'email.notEquals'?: string;
    'email.specified'?: boolean;
    'email.in'?: string[];
    'email.notIn'?: string[];
    'job.contains'?: string;
    'job.doesNotContain'?: string;
    'job.equals'?: string;
    'job.notEquals'?: string;
    'job.specified'?: boolean;
    'job.in'?: string[];
    'job.notIn'?: string[];
    'nationality.contains'?: string;
    'nationality.doesNotContain'?: string;
    'nationality.equals'?: string;
    'nationality.notEquals'?: string;
    'nationality.specified'?: boolean;
    'nationality.in'?: string[];
    'nationality.notIn'?: string[];
    'aslAssigned.contains'?: string;
    'aslAssigned.doesNotContain'?: string;
    'aslAssigned.equals'?: string;
    'aslAssigned.notEquals'?: string;
    'aslAssigned.specified'?: boolean;
    'aslAssigned.in'?: string[];
    'aslAssigned.notIn'?: string[];
    'citizenship.contains'?: string;
    'citizenship.doesNotContain'?: string;
    'citizenship.equals'?: string;
    'citizenship.notEquals'?: string;
    'citizenship.specified'?: boolean;
    'citizenship.in'?: string[];
    'citizenship.notIn'?: string[];
    'qualification.contains'?: string;
    'qualification.doesNotContain'?: string;
    'qualification.equals'?: string;
    'qualification.notEquals'?: string;
    'qualification.specified'?: boolean;
    'qualification.in'?: string[];
    'qualification.notIn'?: string[];
    'maritalStatus.equals'?: 'CELIBE' | 'NUBILE' | 'DIVORZIATO' | 'CONIUGATO' | 'VEDOVO';
    'maritalStatus.notEquals'?: 'CELIBE' | 'NUBILE' | 'DIVORZIATO' | 'CONIUGATO' | 'VEDOVO';
    'maritalStatus.specified'?: boolean;
    'maritalStatus.in'?: ('CELIBE' | 'NUBILE' | 'DIVORZIATO' | 'CONIUGATO' | 'VEDOVO')[];
    'maritalStatus.notIn'?: ('CELIBE' | 'NUBILE' | 'DIVORZIATO' | 'CONIUGATO' | 'VEDOVO')[];
    'anonymizedId.equals'?: string;
    'anonymizedId.notEquals'?: string;
    'anonymizedId.specified'?: boolean;
    'anonymizedId.in'?: string[];
    'anonymizedId.notIn'?: string[];
    'privacyUploadDate.greaterThan'?: string;
    'privacyUploadDate.lessThan'?: string;
    'privacyUploadDate.greaterThanOrEqual'?: string;
    'privacyUploadDate.lessThanOrEqual'?: string;
    'privacyUploadDate.equals'?: string;
    'privacyUploadDate.notEquals'?: string;
    'privacyUploadDate.specified'?: boolean;
    'privacyUploadDate.in'?: string[];
    'privacyUploadDate.notIn'?: string[];
    'clinicalDocumentsId.greaterThan'?: number;
    'clinicalDocumentsId.lessThan'?: number;
    'clinicalDocumentsId.greaterThanOrEqual'?: number;
    'clinicalDocumentsId.lessThanOrEqual'?: number;
    'clinicalDocumentsId.equals'?: number;
    'clinicalDocumentsId.notEquals'?: number;
    'clinicalDocumentsId.specified'?: boolean;
    'clinicalDocumentsId.in'?: number[];
    'clinicalDocumentsId.notIn'?: number[];
    'casesId.greaterThan'?: number;
    'casesId.lessThan'?: number;
    'casesId.greaterThanOrEqual'?: number;
    'casesId.lessThanOrEqual'?: number;
    'casesId.equals'?: number;
    'casesId.notEquals'?: number;
    'casesId.specified'?: boolean;
    'casesId.in'?: number[];
    'casesId.notIn'?: number[];
    'diagnosesId.greaterThan'?: number;
    'diagnosesId.lessThan'?: number;
    'diagnosesId.greaterThanOrEqual'?: number;
    'diagnosesId.lessThanOrEqual'?: number;
    'diagnosesId.equals'?: number;
    'diagnosesId.notEquals'?: number;
    'diagnosesId.specified'?: boolean;
    'diagnosesId.in'?: number[];
    'diagnosesId.notIn'?: number[];
    'diseasesId.greaterThan'?: number;
    'diseasesId.lessThan'?: number;
    'diseasesId.greaterThanOrEqual'?: number;
    'diseasesId.lessThanOrEqual'?: number;
    'diseasesId.equals'?: number;
    'diseasesId.notEquals'?: number;
    'diseasesId.specified'?: boolean;
    'diseasesId.in'?: number[];
    'diseasesId.notIn'?: number[];
    distinct?: boolean;
    page?: number;
    size?: number;
    sort?: string[];
  }) => {
    const response = await api.get<PatientsDTO[]>('/patients', {
      params: {
        ...params,
        sort: params?.sort?.join(',')
      }
    });
    return response.data;
  },

  getPatientById: async (id: number) => {
    const response = await api.get<PatientsDTO>(`/patients/${id}`);
    return response.data;
  },

  createPatient: async (patientData: PatientsDTO) => {
    const response = await api.post<PatientsDTO>('/patients', patientData);
    return response.data;
  },

  updatePatient: async (id: number, patientData: PatientsDTO) => {
    const response = await api.put<PatientsDTO>(`/patients/${id}`, patientData);
    return response.data;
  },

  deletePatient: async (id: number) => {
    await api.delete(`/patients/${id}`);
  },

  partialUpdatePatient: async (id: number, patientData: Partial<PatientsDTO>) => {
    const response = await api.patch<PatientsDTO>(`/patients/${id}`, patientData);
    return response.data;
  },

  countPatients: async (params?: {
    // Stessi parametri di getAllPatients, esclusi page, size e sort
  }) => {
    const response = await api.get<number>('/patients/count', { params });
    return response.data;
  }
};